import { Brick, registerBrick, Config, Auth } from 'olympe';
import { getApplicationContext } from './Context';
import { getLogger } from '@olympeio/core';

export default class GetMSTokenAndSetInSession extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} clientId 
     * @param {*} clientSecret
     * @param {function()} forwardEvent
     */
    async update($, [clientId, clientSecret, isBackendRequest], [forwardEvent]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed every time the brick's input Control Flow is triggered.
        // Override `setupExecution()` to change this behavior.
        getLogger("::GetMSTokenAndSetInSession::").info("::Before calling the auth api::")
        const bearerToken = await getAuthTokenForApiAndSetInStorage($, clientId, clientSecret, isBackendRequest);
        // Trigger the output Control Flow
        forwardEvent();
    }
}


/**
* @public
* @param {Object} token
* @return {!Object}
*/
async function getAuthTokenForApiAndSetInStorage(context, clientId, clientSecret, isBackendRequest = false) {
    try {
        let access_Token = '';

        // Call the api and get the 
        const proxyUrl = Config.getParameter('http_proxy_path');
        console.log("proxyUrl:", proxyUrl);
        console.log("isBackendRequest:", isBackendRequest);

        const authTokenUrl = "https://login.microsoftonline.com/12a3af23-a769-4654-847f-958f3d479f4a/oauth2/v2.0/token";

        if (!isBackendRequest) {
            // Frontend Call from application
                        
            // const clientSecret = getApplicationContext(context).get('kvClientSecret');       
            // console.log("GetMSTokenAndSetInSession - Secret from key vault is " + clientSecret);

            let body = {
                destination: authTokenUrl,
                token: Auth.getUserToken().nonce,
                headers: {
                    Accept: "*/*",
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                opperation: 'POST',
                payload: {
                    client_id: clientId,
                    client_secret: clientSecret,
                    grant_type: "client_credentials",
                    scope: `api://${clientId}/.default`
                },
            };

            const request = await fetch(proxyUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            const result = await request.json();
            console.log("::::::::::::::::::: result :::::::::::::::::::::::::", result);
            access_Token = result?.access_token;

            sessionStorage.setItem("ms_auth_token", access_Token);
        }
        else {
            // Backend Job scheduler call
            // Direct call oauth endpoint without proxy wrapper!
            // No concept of session storage exists during this stage!

            const body = new URLSearchParams({
                client_id: clientId,
                client_secret: clientSecret,
                grant_type: "client_credentials",
                scope: `api://${clientId}/.default`
            });

            const request = await fetch(authTokenUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Accept": "application/json"
                },
                body: body
            });

            const result = await request.json();  
            console.log("::::::::::::::::::: result from Backend Service :::::::::::::::::::::::::", result); 
            access_Token = result?.access_token;         
        }

        getLogger("::::get User token:::::").info(":::: access Token:::", access_Token);        
        getApplicationContext(context).set("ms_auth_token", access_Token);

        return access_Token;
    }
    // Error while decoding
    catch (e) {
        getLogger('GetMSTokenAndSetInSession').error('GetMSTokenAndSetInSession - OAuth error: ', e);
        return {};
    }
}
registerBrick('019e688808c9b626854c', GetMSTokenAndSetInSession);
